<template>
	<div class="radioCascader">
        <div class="d-flex parent_">
            <label class="checkbox-box" >
                <label class="checkbox-warp fl" :class="radiodata.length === platformTypes.length? 'curr' : ''"  @click.stop="selectAll()">
                    <input name="" type="checkbox" class="checkbox" :value="radioname" v-model="platformType" /> 
                    <i class="icons checkbox-icon"></i>
                </label>
                <div class="hidden">{{radioname}}</div>
            </label>
            <div class="grid-info cascaderTip" v-if="mediaLevelTips[radioname]!=undefined">
                <i class="icons icons-question-circle"></i> 
                <p class="grid-tip shadow_">{{mediaLevelTips[radioname]}}</p>
            </div>
            <!-- <i class="icons icons-question-circle cascaderTip" :title="mediaLevelTips[radioname]"></i>  -->
        </div>
        <div class="d-flex mb10 pl30 child_" style="width:652px;flex-wrap:wrap">
            <label class="checkbox-box" v-for="(items,index1) in radiodata" :key="index1">
                <label class="checkbox-warp fl" :class="platformTypes.indexOf(items) != -1 ? 'curr' : ''">
                    <input name="" type="checkbox" class="checkbox" v-model="platformTypes" :value="items" /> 
                    <i class="icons checkbox-icon"></i>
                </label>
                <div class="hidden ac">{{items}}</div>
            </label>
        </div>
	</div>
</template>
<script>
import {mapState} from 'vuex';
import Dialog from './dialog.vue';
export default {
    name: "radioCascader",
    components:{Dialog},
    computed:{
        ...mapState({
            mediaLevelTips: state => state.show.companyinfo.mediaLevelTipsList
        })
    },
    props: {
		radiodata:{
            type:Array,
            default:{}
        },
        radioname:{
			type:String,
			default:''
		},
        morenzhiData:{
            type:Object,
            default:{}
        }
	},
    data() {
        return {
            platformType:[],
            platformTypes:[]
        }
    },
    mounted() {
        let arr = this.morenzhiData[this.radioname];
        if(arr!=undefined){
            this.platformTypes = arr;
        }
    },
	watch:{
		platformTypes(){
            if(this.platformTypes){
                let len = this.platformTypes.length;
                if(len!=this.radiodata.length){
                    this.platformType = [];
                }else{
                    this.platformType = [`${this.radioname}`];
                } 
            }
            let map_ = new Map();
            map_.set(this.radioname,this.platformTypes)
            let obj= Object.create(null);
            for (let[k,v] of map_) {
                obj[k] = v;
            }
            this.$emit('putchildData',obj) 
        },
        // platformType(){
        //     if(this.platformType.length>0){
        //         this.platformTypes = this.radiodata;
        //     }
        // },
	},
    methods: {
        selectAll(){
            if(this.platformTypes.length == this.radiodata.length){
                this.platformTypes = [];
            }else{
                this.platformTypes = this.radiodata;
            }
        }
    },
}
</script>
<style scoped>
    
</style>



// WEBPACK FOOTER //
// src/components/radioCascader.vue